import React from 'react';

const PrivacyPolicy = () => (
  <div data-testid="privacy-page" className="pt-28">
    <section className="py-16 md:py-20 bg-[#1B2432]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <p className="text-[#F57C20] text-xs font-semibold tracking-[0.2em] uppercase mb-3">Legal</p>
        <h1 className="text-4xl sm:text-5xl text-white" style={{ fontFamily: "'Playfair Display', serif" }}>Privacy <span className="text-[#F57C20] italic">Policy</span></h1>
      </div>
    </section>
    <section className="py-16 md:py-20 bg-white">
      <div className="max-w-3xl mx-auto px-6 md:px-12 text-[#6B7280] text-sm leading-relaxed space-y-5">
        <p>Last updated: February 2026</p>
        <h3 className="text-lg text-[#1A1A2E] pt-2 font-semibold">1. Information We Collect</h3>
        <p>We collect personal information you provide during registration and booking: full name, email address, phone number, government ID (for verification), and payment details (processed securely via Razorpay).</p>
        <h3 className="text-lg text-[#1A1A2E] pt-2 font-semibold">2. How We Use Your Information</h3>
        <p>Your information is used to: process bookings, communicate booking confirmations and updates, send indemnity forms, process refunds, and improve our services. We do not sell or share your personal data with third parties for marketing purposes.</p>
        <h3 className="text-lg text-[#1A1A2E] pt-2 font-semibold">3. Data Security</h3>
        <p>We implement industry-standard security measures to protect your data. Payment processing is handled by Razorpay with PCI DSS compliance. Passwords are encrypted using bcrypt hashing.</p>
        <h3 className="text-lg text-[#1A1A2E] pt-2 font-semibold">4. Cookies</h3>
        <p>We use essential cookies to maintain your login session and preferences. No third-party tracking cookies are used.</p>
        <h3 className="text-lg text-[#1A1A2E] pt-2 font-semibold">5. Your Rights</h3>
        <p>You may request access to, correction of, or deletion of your personal data by contacting us at royalgardenlonavala@gmail.com. We will respond within 30 days.</p>
        <h3 className="text-lg text-[#1A1A2E] pt-2 font-semibold">6. Contact</h3>
        <p>For privacy-related queries: royalgardenlonavala@gmail.com | +91 9820088292</p>
      </div>
    </section>
  </div>
);

export default PrivacyPolicy;
